import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP_URL = 'https://wa.me/584242227314?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20seguros';
export const INSTAGRAM_URL = 'https://www.instagram.com/iwannainsurance';
export const LOGO_URL = 'https://img1.wsimg.com/isteam/ip/7f5db289-97cc-4b77-a2e2-425af5ec3c69/logo%20de%20iwanna.jpeg';

export const trackClick = (partner) => axios.post(`${API}/analytics/click`, { partner }).catch(() => {});

export const openWhatsApp = () => {
  trackClick('WhatsApp');
  window.open(WHATSAPP_URL, '_blank');
};

export const trackShare = (network) => trackClick(`Compartir ${network}`);

export const TIPOS_SEGURO = ['Seguro de Viaje', 'Seguro de Salud', 'Seguro de Vida', 'Seguro de Auto', 'Seguro Empresarial'];

export const EMPRESAS_ASOCIADAS = [
  {
    nombre: 'Orange Travel Assist',
    logo: 'https://orangetravelassist.net/app-website/images/logo-orange.png',
    descripcion: 'Soluciones digitales para viajeros modernos',
    link: 'https://orangetravelassist.net/ota002175',
    beneficios: ['Tarjeta SIM', 'Salas VIP', 'Conectividad global'],
    color: 'from-orange-500 to-yellow-400',
  },
  {
    nombre: 'Mercantil Travel',
    logo: 'https://www.mercantilseguros.com/_next/image?url=%2Fimages%2Fmercantil-coloured-logo.png&w=256&q=75',
    descripcion: 'Líder en seguros con 37 años de experiencia',
    link: 'https://www1.mercantilseguros.com/as/viajes/MRC037095',
    beneficios: ['Líder en Venezuela', 'Viajes globales', 'Confianza total'],
    color: 'from-indigo-500 to-purple-400',
  },
  {
    nombre: 'Runaway Travel Assistance',
    logo: 'https://runawaytravelassistance.com/app/pages/site/images/run_logo_h.png',
    descripcion: 'Asistencia al viajero 24/7 en todo el mundo',
    link: 'https://runawaytravelassistance.com/M2KA31SPA',
    beneficios: ['Planes hasta 99 años', 'Estudiantes y corporativo', 'eSIM internacional'],
    color: 'from-emerald-500 to-teal-400',
  },
  {
    nombre: 'World Medic Assist',
    logo: 'https://worldmedicassist.com/site/assets/image/logo.svg',
    descripcion: 'Cobertura médica internacional para tu viaje',
    link: 'https://worldmedicassist.com/adminapp/vurl/11721/ES',
    beneficios: ['Asistencia médica global', 'Atención 24 horas', 'Cotización en línea'],
    color: 'from-sky-500 to-blue-400',
  },
];
